function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 146.2432 21.6338)",
  fill: "#134074",
  fontFamily: "'Poppins'",
  fontSize: 32
}, "Netherlands");

var _ref3 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 353.3486 288.0186)",
  fill: "#081A2F",
  fontFamily: "'Poppins'",
  fontSize: 32
}, "Germany");

var _ref4 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 150.0156 360.334)",
  fill: "#FF912D",
  fontFamily: "'Poppins'",
  fontSize: 32
}, "Slovakia");

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  fill: "#134074",
  d: "M169.989,220.848c-6.06-9.88-9.559-21.5-9.559-33.94c0-35.9,29.105-65.005,65.006-65.005 s65.007,29.104,65.007,65.005c0,9.233-1.938,18.012-5.408,25.966l59.573,25.953c28.672-65.819-1.439-142.419-67.257-171.093 c-12.92-5.628-26.254-8.981-39.56-10.253l-12.356-21.403l-12.364,21.414c-45.473,4.387-87.27,32.649-106.81,77.501 c-18.974,43.556-12.199,91.824,13.622,127.81c-1.875-2.614-3.65-5.292-5.322-8.027L169.989,220.848z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  fill: "#081A2F",
  d: "M119.95,262.895c-0.021-0.031-0.044-0.062-0.066-0.093 C119.906,262.833,119.929,262.863,119.95,262.895z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF912D",
  d: "M266.294,237.457c-11.165,9.036-25.375,14.457-40.857,14.457c-23.462,0-44.017-12.433-55.447-31.066 l-55.428,33.927c1.672,2.735,3.447,5.413,5.322,8.027c0.022,0.031,0.045,0.062,0.066,0.093c1.848,2.569,3.792,5.076,5.832,7.513 c0.062,0.075,0.125,0.149,0.187,0.224c2.005,2.386,4.102,4.705,6.287,6.952c0.104,0.106,0.208,0.215,0.313,0.32 c2.159,2.206,4.404,4.339,6.732,6.397c0.141,0.125,0.282,0.251,0.422,0.375c1.153,1.01,2.325,2.004,3.518,2.977 c0.092,0.074,0.186,0.147,0.278,0.223c1.114,0.904,2.249,1.789,3.398,2.659c0.166,0.126,0.33,0.252,0.496,0.377 c1.204,0.902,2.426,1.785,3.667,2.648c0.196,0.136,0.394,0.269,0.59,0.402c1.133,0.78,2.281,1.544,3.445,2.29 c0.17,0.108,0.336,0.221,0.507,0.328c1.26,0.801,2.541,1.578,3.836,2.34c0.269,0.159,0.541,0.313,0.813,0.472 c1.211,0.698,2.434,1.383,3.674,2.048c0.128,0.068,0.254,0.141,0.383,0.209c1.328,0.705,2.677,1.385,4.039,2.049 c0.319,0.155,0.639,0.31,0.96,0.462c1.382,0.661,2.776,1.308,4.192,1.925c1.282,0.559,2.569,1.088,3.859,1.601 c0.355,0.142,0.711,0.279,1.068,0.417c1.039,0.404,2.08,0.794,3.125,1.169c0.28,0.101,0.559,0.206,0.839,0.304 c1.306,0.46,2.616,0.899,3.929,1.314c0.223,0.071,0.447,0.137,0.672,0.205c1.121,0.35,2.244,0.681,3.369,0.998 c0.171,0.048,0.342,0.104,0.514,0.151l8.475,23.227l15.866-18.94l0.011-0.014c33.291,2.618,66.25-7.782,91.917-28.497 L266.294,237.457z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  fill: "#081A2F",
  d: "M335.535,256.039l-0.001-0.004c0.809-1.291,1.594-2.603,2.36-3.929 c0.071-0.122,0.142-0.243,0.212-0.365c1.485-2.585,2.888-5.242,4.21-7.962c0.151-0.313,0.304-0.625,0.452-0.939 c0.631-1.324,1.248-2.658,1.84-4.014l-59.573-25.953c-4.205,9.639-10.673,18.056-18.741,24.584l40.869,50.562 c4.693-3.786,9.134-7.923,13.298-12.38l0.008,0.001l24.497,3.262L335.535,256.039z"
}));

var SvgDebondtIconGraph = function SvgDebondtIconGraph(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "517.575px",
    height: "366px",
    viewBox: "0 0 517.575 366",
    enableBackground: "new 0 0 517.575 366",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      textTransform: "capitalize"
    }
  }, _ref2, _ref3, _ref4), _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDebondtIconGraph, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DEBONDT_ICON_graph.ceb8c7de.svg";
export { ForwardRef as ReactComponent };